module.exports = __webpack_public_path__ + "static/media/avatar.ca7776a8.png";